import Image from "next/image"
import { Container } from "@octopus-energy/coral/atoms"
import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { StoryblokComponent } from "@storyblok/react"
import {
    StyledCover,
    StyledGradient,
} from "@/features/greenEnergy/components/LandscapeIntro/LandscapeIntro.styled"
import { type SbBlokGreenEnergyHeader } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyHeader
}

export default function DynamicGreenEnergyHeader({ blok }: DynamicRenewableEnergyProps) {
    if (!blok?.blocks?.length) {
        return (
            <StoryblokMissingField
                blok="Container"
                field="Blocks"
            />
        )
    }

    return (
        <Container theme="base900">
            <StyledCover>
                <Image
                    src={blok.cover.filename}
                    width={1440}
                    height={410}
                    alt={blok.cover.alt}
                    style={{
                        width: "100%",
                        objectPosition: "center",
                        objectFit: "cover",
                    }}
                />
                <StyledGradient />
            </StyledCover>
            <Container
                position="relative"
                maxWidthPreset="lg"
                marginX="auto"
                paddingBottom="xxxl"
            >
                {blok.blocks.map((nestedBlok) => (
                    <StoryblokComponent
                        blok={nestedBlok}
                        key={nestedBlok._uid}
                    />
                ))}
            </Container>
        </Container>
    )
}
